import { apiSlice, createClientV2QueryFn } from 'store/slices/api';
import { parseQueryParams } from 'store/slices/utils';
import { ListResponse, QueryParams } from 'types/api';
import { CLIENT_V2_URLS } from 'store/slices/constants/clientV2';
import { UserSchema } from 'types/clientV2/users';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsersV2: builder.query<
      ListResponse<UserSchema>,
      QueryParams<UserSchema>
    >({
      queryFn: createClientV2QueryFn((params) =>
        CLIENT_V2_URLS.USERS(parseQueryParams<UserSchema>(params))
      ),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: UserSchema) =>
                  ({
                    type: 'UsersV2',
                    id,
                  } as const)
              ),
              { type: 'UsersV2', id: 'LIST' },
            ]
          : [{ type: 'UsersV2', id: 'LIST' }],
    }),
  }),
});

export const { useGetUsersV2Query } = extendedApiSlice;
